// extracted by mini-css-extract-plugin
export default {"noMarginTop":"_2W2aR","descriptionList":"_28fi4"};